// @flow

import type { State } from "@store/reducers";
import type { DefaultStandardScript } from "@modules/service/reducer/default-standard-scripts/types";
import { ApprovalStateEnum } from "@modules/service/constants";
import type { ApprovableContainer } from "@modules/service/types";

const { DRAFT_ONLY, ACTIVE_WITH_DRAFT } = ApprovalStateEnum;

export const getDefaultStandardScriptsList = (state: State): ?Array<DefaultStandardScript> =>
  (state.service.defaultStandardScripts.list || {}).content || [];

export const getDefaultStandardScriptContainer = (
  state: State,
): ?ApprovableContainer<DefaultStandardScript> => state.service.defaultStandardScripts.current;

export const getDefaultStandardScriptDraft = (state: State): ?DefaultStandardScript =>
  state.service.defaultStandardScripts.draft;

// MODALS
export const getShowDefaultStandardScriptEditModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showEditModal;

export const getShowDefaultStandardScriptDisableModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showDisableModal;

export const getShowDefaultStandardScriptDiscardModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showDiscardModal;

export const getShowDefaultStandardScriptCancelModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showCancelModal;

export const getShowDefaultStandardScriptCancelDiscardModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showCancelDiscardModal;

export const getShowDefaultStandardScriptSubmitModal = (state: State): boolean =>
  state.service.defaultStandardScripts.modals.showSubmitModal;
